import React from 'react';
import { Modal } from '../_components';

import { useModal } from '../_contexts';

import { MapMarkerForm } from './forms';

export function MapMarkerModal(props) {
  // console.log('Map Marker Modal Props', props.event.props);
  const { event } = props;
  const { map, coords, marker, chronicle, zoom } = event.props;
  // console.log('map', map, 'marker', marker);

  const title = (marker ? 'Edit' : 'New') + ' Map Marker';

  //Extract and prep the props to pass to the form
  const { closeModal } = useModal();

  return (
    <Modal
      id="mapMarkerModal"
      // backdrop
      title={title}
      icon="fas fa-map-marker"
      size="md"
      open={true}
      onClose={() => closeModal()}
    >
      <MapMarkerForm
        map={map}
        coords={coords}
        marker={marker}
        chronicle={chronicle}
        zoom={zoom}
      />
    </Modal>
  );
}
